var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.45,17.75A12.48,12.48,0,1,1,9.36,7.16a1.86,1.86,0,0,1,1-.41,1.31,1.31,0,0,1,.71,2.43A10.46,10.46,0,0,0,9.27,10.5a9.85,9.85,0,0,0,4.59,16.85A9.52,9.52,0,0,0,23.57,24a9.22,9.22,0,0,0,2.25-6.73,9.71,9.71,0,0,0-4.9-8.07A1.3,1.3,0,0,1,20.76,7a1.23,1.23,0,0,1,1.44-.08,12.46,12.46,0,0,1,6.05,8.6c.12.73.17,1.48.25,2.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.28,10.42v6.7a1.31,1.31,0,0,1-2.27.94,1.36,1.36,0,0,1-.34-1V3.75a1.31,1.31,0,1,1,2.61,0v6.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3c58a55d5338f347b3ad24bd9d9cff2e.svg";
export { ForwardRef as ReactComponent };